import { render, staticRenderFns } from "./ProfileBoxTokens.vue?vue&type=template&id=48ceb538&"
import script from "./ProfileBoxTokens.vue?vue&type=script&lang=js&"
export * from "./ProfileBoxTokens.vue?vue&type=script&lang=js&"
import style0 from "./ProfileBoxTokens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports